module.exports = __webpack_public_path__ + "img/sahin-yesilyaprak-V7uP-XzqX18-unsplash.2ed016f5.jpg";